import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoLoaderComponent } from './logo-loader.component';

@NgModule({
  declarations: [LogoLoaderComponent],
  imports: [CommonModule],
  exports: [LogoLoaderComponent],
})
export class LogoLoaderComponentModule {}
